module.exports = __webpack_public_path__ + "img/lib_region_flag_zw.b7b45e10.png";